module.exports = __webpack_public_path__ + "img/Demographics.0a1415e6.svg";